(() => {
  const init = scope => {
    const products = [...scope.querySelectorAll('[data-product-root]')];
    if (scope.matches?.('[data-product-root]')) products.unshift(scope);
    products.forEach(product => {
      if (product.dataset.experienceReady) return;
      product.dataset.experienceReady = 'true';
      const colors = product.querySelector('.fr-option-group--color');
      const slot = product.querySelector('[data-gallery-color-slot]');
      if (colors && slot) {
        const views = slot.closest('[data-apparel-gallery]')?.querySelector('.fr-apparel-gallery__view-row');
        if (views) views.after(slot);
        slot.append(colors);
      }


      const sizeGroup = product.querySelector('.fr-option-group--size');
      if (sizeGroup && slot) {
        const sizeHome = document.createElement('span');
        sizeHome.hidden = true;
        sizeGroup.before(sizeHome);
        const mobileSize = window.matchMedia('(max-width: 760px)');
        const placeSize = () => {
          if (mobileSize.matches) slot.append(sizeGroup);
          else sizeHome.after(sizeGroup);
        };
        placeSize();
        mobileSize.addEventListener('change', placeSize);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(product)) mobileSize.removeEventListener('change', placeSize);
        });
      }

      product.querySelectorAll('[data-apparel-gallery]').forEach(gallery => {
        const opener = gallery.querySelector('[data-image-zoom-open]');
        const dialog = gallery.querySelector('[data-image-zoom]');
        if (!opener || !dialog) return;
        const canvas = dialog.querySelector('[data-zoom-canvas]');
        const img = dialog.querySelector('[data-zoom-image]');
        const status = dialog.querySelector('[data-zoom-status]');
        const level = dialog.querySelector('[data-zoom-level]');
        const minus = dialog.querySelector('[data-zoom-out]');
        const plus = dialog.querySelector('[data-zoom-in]');
        const mirrorEnabled = gallery.dataset.mirrorEnabled === 'true';
        const mirrorButtons = [...dialog.querySelectorAll('[data-zoom-mirror]')];
        const pointers = new Map();
        let scale = 1, x = 0, y = 0, baseW = 1, baseH = 1, mirror = false;
        let pinch = null, moved = false, pinched = false, lastTap = null;
        const maxScale = () => Math.max(1, Math.min(4, (img.naturalWidth || 3200) / baseW));
        const render = () => {
          const maxX = Math.max(0, (baseW * scale - canvas.clientWidth) / 2);
          const maxY = Math.max(0, (baseH * scale - canvas.clientHeight) / 2);
          x = Math.max(-maxX, Math.min(maxX, x));
          y = Math.max(-maxY, Math.min(maxY, y));
          img.style.transform = 'translate(-50%, -50%) translate(' + x + 'px,' + y + 'px) scale(' + scale + ') scaleX(' + (mirror ? -1 : 1) + ')';
          level.textContent = Math.round(scale * 100) + '%';
          minus.disabled = scale <= 1;
          plus.disabled = scale >= maxScale();
          canvas.classList.toggle('is-zoomed', scale > 1);
          mirrorButtons.forEach(button => button.setAttribute('aria-pressed', String((button.dataset.zoomMirror === 'true') === mirror)));
        };
        const fit = () => {
          const ratio = (img.naturalWidth || 1) / (img.naturalHeight || 1);
          baseW = Math.min(canvas.clientWidth, canvas.clientHeight * ratio);
          baseH = baseW / ratio;
          img.style.width = baseW + 'px';
          img.style.height = baseH + 'px';
          scale = Math.min(scale, maxScale());
          render();
        };
        const zoomAt = (next, clientX, clientY) => {
          const box = canvas.getBoundingClientRect();
          const px = clientX === undefined ? 0 : clientX - box.left - box.width / 2;
          const py = clientY === undefined ? 0 : clientY - box.top - box.height / 2;
          next = Math.max(1, Math.min(maxScale(), next));
          const factor = next / scale;
          x = px - (px - x) * factor;
          y = py - (py - y) * factor;
          scale = next;
          render();
        };
        const reset = () => { scale = 1; x = 0; y = 0; render(); };
        const pair = () => {
          const [a, b] = [...pointers.values()];
          return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2, distance: Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)) };
        };
        let zoomFrames = [], zoomIndex = 0;
        const showPhoto = () => {
          const frame = zoomFrames[zoomIndex], image = frame?.querySelector('img');
          if (!image) return;
          dialog.querySelector('[data-zoom-caption]').textContent = [frame.dataset.apparelColorName, frame.dataset.apparelViewLabel].filter(Boolean).join(' · ');
          dialog.querySelector('[data-zoom-position]').textContent = (zoomIndex + 1) + ' / ' + zoomFrames.length;
          dialog.querySelector('[data-zoom-previous]').disabled = zoomFrames.length < 2;
          dialog.querySelector('[data-zoom-next]').disabled = zoomFrames.length < 2;
          img.alt = image.alt;
          status.textContent = status.dataset.loading; status.hidden = false;
          img.src = frame.dataset.zoomSrc || image.currentSrc || image.src;
          scale = 1; x = 0; y = 0; pointers.clear(); pinch = null; lastTap = null;
          fit();
          if (img.complete && img.naturalWidth) status.hidden = true;
        };
        const step = direction => { zoomIndex = (zoomIndex + direction + zoomFrames.length) % zoomFrames.length; showPhoto(); };
        dialog.querySelector('[data-zoom-previous]').addEventListener('click', () => step(-1));
        dialog.querySelector('[data-zoom-next]').addEventListener('click', () => step(1));
        mirrorButtons.forEach(button => button.addEventListener('click', () => {
          mirror = mirrorEnabled && button.dataset.zoomMirror === 'true';
          gallery.dispatchEvent(new CustomEvent('fr:apparel-mirror-change', { detail: { mirrored: mirror } }));
          render();
        }));
        gallery.addEventListener('fr:apparel-state', event => {
          mirror = mirrorEnabled && event.detail?.mirrored === true;
          if (dialog.open) render();
        });
        opener.addEventListener('click', () => {
          const frames = [...gallery.querySelectorAll('[data-apparel-frame]')];
          const frame = frames.find(item => !item.hidden);
          if (!frame) return;
          const group = frames.filter(item => item.dataset.apparelGroup === frame.dataset.apparelGroup);
          zoomFrames = group.length > 1 ? group : frames;
          zoomIndex = Math.max(0, zoomFrames.indexOf(frame));
          mirror = mirrorEnabled && gallery.dataset.mirrored === 'true';
          document.body.classList.add('fr-zoom-open'); dialog.showModal(); showPhoto();
        });
        img.addEventListener('load', () => { status.hidden = true; if (dialog.open) fit(); });
        img.addEventListener('error', () => { status.textContent = status.dataset.error; status.hidden = false; });
        dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => {
          document.body.classList.remove('fr-zoom-open');
          pointers.clear();
          canvas.classList.remove('is-dragging');
          opener.focus({ preventScroll: true });
        });
        plus.addEventListener('click', () => zoomAt(scale + 0.5));
        minus.addEventListener('click', () => zoomAt(scale - 0.5));
        dialog.querySelector('[data-zoom-reset]').addEventListener('click', reset);
        canvas.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          canvas.setPointerCapture(event.pointerId);
          pointers.set(event.pointerId, { x: event.clientX, y: event.clientY, startX: event.clientX, startY: event.clientY });
          if (pointers.size === 1) { moved = false; pinched = false; }
          if (pointers.size === 2) { pinch = pair(); pinched = true; }
          canvas.classList.add('is-dragging');
        });
        canvas.addEventListener('pointermove', event => {
          const old = pointers.get(event.pointerId);
          if (!old) return;
          const current = { ...old, x: event.clientX, y: event.clientY };
          pointers.set(event.pointerId, current);
          if (Math.hypot(current.x - old.startX, current.y - old.startY) > 8) moved = true;
          if (pointers.size >= 2) {
            const next = pair();
            if (pinch) {
              x += next.x - pinch.x; y += next.y - pinch.y;
              zoomAt(scale * next.distance / pinch.distance, next.x, next.y);
            }
            pinch = next;
          } else if (scale > 1) {
            x += current.x - old.x; y += current.y - old.y; render();
          }
        });
        const release = event => {
          if (!pointers.has(event.pointerId)) return;
          pointers.delete(event.pointerId);
          pinch = null;
          if (!pointers.size) {
            canvas.classList.remove('is-dragging');
            if (!moved && !pinched && event.type === 'pointerup') {
              if (event.pointerType === 'mouse') zoomAt(scale > 1 ? 1 : 2, event.clientX, event.clientY);
              else {
                const now = performance.now();
                if (lastTap && now - lastTap.time < 320 && Math.hypot(event.clientX - lastTap.x, event.clientY - lastTap.y) < 32) {
                  zoomAt(scale > 1 ? 1 : 2, event.clientX, event.clientY); lastTap = null;
                } else lastTap = { time: now, x: event.clientX, y: event.clientY };
              }
            }
          }
        };
        canvas.addEventListener('pointerup', release);
        canvas.addEventListener('pointercancel', release);
        canvas.addEventListener('lostpointercapture', release);
        canvas.addEventListener('wheel', event => {
          event.preventDefault();
          zoomAt(scale * (event.deltaY < 0 ? 1.15 : 1 / 1.15), event.clientX, event.clientY);
        }, { passive: false });
        dialog.addEventListener('keydown', event => {
          if (scale === 1 && event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
          if (scale === 1 && event.key === 'ArrowRight') { event.preventDefault(); step(1); }
          if (event.key === '+' || event.key === '=') { event.preventDefault(); zoomAt(scale + 0.5); }
          if (event.key === '-') { event.preventDefault(); zoomAt(scale - 0.5); }
          if (event.key === 'Home') { event.preventDefault(); reset(); }
          if (scale > 1 && ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) {
            event.preventDefault();
            if (event.key === 'ArrowLeft') x += 50;
            if (event.key === 'ArrowRight') x -= 50;
            if (event.key === 'ArrowUp') y += 50;
            if (event.key === 'ArrowDown') y -= 50;
            render();
          }
        });
        new ResizeObserver(() => { if (dialog.open) fit(); }).observe(canvas);
        window.addEventListener('pagehide', () => { if (dialog.open) dialog.close(); });
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(gallery) && dialog.open) dialog.close();
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


